import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";

@NgFilter({
    token: Token.AssetFilter,
    dependencies: [
        Token.StorageService
    ]
})
export class AssetFilter {
    constructor(
        storageService: StorageService
    ) {
        return ((relativePath: string) => {
            return storageService.getAssetUrl(relativePath)
        });
    }
}
